import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const XCircleContained = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M13.182 7.87868C13.4749 7.58579 13.4749 7.11091 13.182 6.81802C12.8891 6.52513 12.4142 6.52513 12.1213 6.81802L12.6517 7.34835L13.182 7.87868ZM6.81802 12.1213C6.52513 12.4142 6.52513 12.8891 6.81802 13.182C7.11091 13.4749 7.58579 13.4749 7.87868 13.182L7.34835 12.6517L6.81802 12.1213ZM12.1213 13.182C12.4142 13.4749 12.8891 13.4749 13.182 13.182C13.4749 12.8891 13.4749 12.4142 13.182 12.1213L12.6517 12.6517L12.1213 13.182ZM7.87868 6.81802C7.58579 6.52513 7.11091 6.52513 6.81802 6.81802C6.52513 7.11091 6.52513 7.58579 6.81802 7.87868L7.34835 7.34835L7.87868 6.81802ZM17.5 10H16.75C16.75 13.7279 13.7279 16.75 10 16.75V17.5V18.25C14.5563 18.25 18.25 14.5563 18.25 10H17.5ZM10 17.5V16.75C6.27208 16.75 3.25 13.7279 3.25 10H2.5H1.75C1.75 14.5563 5.44365 18.25 10 18.25V17.5ZM2.5 10H3.25C3.25 6.27208 6.27208 3.25 10 3.25V2.5V1.75C5.44365 1.75 1.75 5.44365 1.75 10H2.5ZM10 2.5V3.25C13.7279 3.25 16.75 6.27208 16.75 10H17.5H18.25C18.25 5.44365 14.5563 1.75 10 1.75V2.5ZM12.6517 7.34835L12.1213 6.81802L9.46967 9.46967L10 10L10.5303 10.5303L13.182 7.87868L12.6517 7.34835ZM10 10L9.46967 9.46967L6.81802 12.1213L7.34835 12.6517L7.87868 13.182L10.5303 10.5303L10 10ZM12.6517 12.6517L13.182 12.1213L10.5303 9.46967L10 10L9.46967 10.5303L12.1213 13.182L12.6517 12.6517ZM10 10L10.5303 9.46967L7.87868 6.81802L7.34835 7.34835L6.81802 7.87868L9.46967 10.5303L10 10Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default XCircleContained
